<template>
  <div>
    <section id="page-adventure" class="mdl-grid adv-content" >
      <div class="adv-image-container mdl-cell mdl-cell--12-col mdl-grid ">
          <div class="mdl-cell mdl-cell--4-col mdl-cell--middle mdl-cell--stretch" >
            <div class="adv-help mdl-card mdl-shadow--2dp adv-no-posts" style="height: 100%; width: 100%;"> 
              <div style="background-image: url(images/icons/icon-512x512.png); background-position: center; background-repeat: no-repeat; background-size: contain; width: 100%; height: 120px; margin-top: 20px">
                </div>  
              <div class="mdl-card__title">
                <h2 class="mdl-card__title-text">
                  Design your own adventure</h2>
              </div>
              <div class="mdl-card__supporting-text">
                Make your own adventure with this easy interface.
              </div>
              <div class="mdl-card__actions mdl-card--border">
                <a @click="createAdventure" class="mdl-button mdl-button--raised mdl-button--colored mdl-js-button mdl-js-ripple-effect">
                  <!--<i class="material-icons">add</i>--> 
                  New Adventure
                </a>
              </div>
            </div>
          </div>
          <div v-for="(item, itemKey) in items" class="mdl-cell mdl-cell--stretch mdl-cell--4-col">
            <div class="mdl-card mdl-shadow--2dp" style="height: 100%; width: 100%; ">
              <div v-if="item.cover" class="mdl-card__title" :style="'background-color: #777777; background-image: url('+item.cover+'); padding: 28.125% 0 28.125% 0; background-repeat: no-repeat; background-size: contain;  background-position: center;'">
              </div>
              <div v-else class="mdl-card__title" style="display: inline; background-color: #ccc; color: #999; font-size: 24px; font-weight: bolder; height: 0px; width: 100%; padding: 28.125% 0 28.125% 0; text-align: center;">
                NO COVER
              </div>
              <div class="mdl-card__title">
                <h2 class="mdl-card__title-text">{{item.name}}</h2>
              </div>
              <div class="mdl-card__supporting-text">
                {{item.description}}
              </div>
              <div class="mdl-card__actions mdl-card--border">
                <router-link v-if="!item.published" :to="('/editor/'+itemKey)" class="mdl-cell--4-col mdl-cell--12-col-tablet mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect">
                  <!--<i class="material-icons">edit</i>-->
                  Edit
                </router-link>
                <router-link  :to="('/editor/play/'+itemKey)" class="mdl-cell--4-col mdl-cell--12-col-tablet mdl-button mdl-js-button mdl-js-ripple-effect">
                  <!--<i class="material-icons">play_arrow</i> -->
                  Play
                </router-link>
                <button v-if="!item.published"  class="mdl-cell--4-col mdl-cell--12-col-tablet mdl-button mdl-js-button mdl-js-ripple-effect" @click="showDialog('publishAdventure', itemKey)">
                  <!--<i class="material-icons">publish</i>--> 
                  Publish
                </button>
                <button v-if="item.published" class="mdl-cell--4-col mdl-cell--12-col-tablet mdl-button mdl-js-button mdl-js-ripple-effect" @click="showDialog('shareAdventure', itemKey)">
                  <!--<i class="material-icons">share</i> -->
                  Share
                </button>
              </div>
            </div>
          </div>
      </div>
      <!--<div v-if="isFull" class="adv-next-page-button">
        <button class="mdl-button mdl-js-button mdl-button--raised mdl-button--fab">
          <i class="material-icons">expand_more</i>
        </button>
      </div>-->
    </section>
    <dialog class="mdl-dialog publishAdventure">
      <div class="mdl-dialog__title">Are you sure you want to publish this adventure?</div>
      <div class="mdl-dialog__content">
        <p>
          After publishing you will not be able to make any changes.
        </p>
      </div>
      <div class="mdl-dialog__actions mdl-dialog__actions">
        <button type="button" class="mdl-button" @click="publishAdventure">PUBLISH</button>
        <button type="button" class="mdl-button close">CANCEL</button>
      </div>
    </dialog>
    <dialog class="mdl-dialog shareAdventure">
      <div class="mdl-dialog__title">Share this adventure</div>
      <div class="mdl-dialog__content">
        <p>
          Share this URL with your friends:
          <input id="dialog_copy_text" class="mdl-textfield" style="width: 100%;" :value="'http://studio.adventify.com/#/play/'+selectedId" ></input>
            <button class="mdl-button mdl-button--raised" onclick="document.querySelector('#dialog_copy_text').select(); document.execCommand('copy'); document.querySelector('#dialog_copy_result').innerHTML = 'URL copied to clipboard!';" style="position: relative; top: 5px; ">SELECT AND COPY</button>
            <div style="position: relative; float: left;" id="dialog_copy_result">
          </div>
        </p>
      </div>
      <div class="mdl-dialog__actions mdl-dialog__actions">
        <button type="button" class="mdl-button close">CLOSE</button>
      </div>
    </dialog>
  </div>
</template>

<script>

var sectionMyAdventures;

export default{
  data: ()=>({
    advRef: {},
    advPubRef: {},
    advDetailsRef: {},
    items: {},
    selectedId: "",
    user: null
  }),
  created(){
    sectionMyAdventures = this;
    this.user = window.firebase.auth().currentUser;
    if(this.user) this.startSetup();
    window.firebase.auth().onAuthStateChanged((user) => {
      sectionMyAdventures.user = user;
      if(sectionMyAdventures.user)
      sectionMyAdventures.startSetup();
    });
  },
  methods: {
    createAdventure(){
      var user = window.firebase.auth().currentUser;
      var newAdventure = {
        owner: {
          uid: user.uid,
          name: user.displayName
        }
      };
      var adv = this.advRef.push(newAdventure);
      var date = new Date();
      var newAdventureDetails = {
        'name': 'Untitled Adventure',
        'description': 'Adventure Created: '+ date.getDate() + "/" + date.getMonth() + "/" + date.getFullYear()
      }
      this.advDetailsRef.child(adv.key).set(newAdventureDetails);
    },
    startSetup(){
      this.advRef = window.firebase.database().ref('adventures');
      this.advPubRef = window.firebase.database().ref('publishedAdventures');
      this.advDetailsRef = window.firebase.database().ref('adventureDetails/'+this.user.uid);
      this.advDetailsRef.on('value', function(snapshot) {
          sectionMyAdventures.items = snapshot.val();
      });
    },
    showDialog(dialogId, selectedId){
        this.selectedId = selectedId;
        var dialog = document.querySelector('dialog.'+dialogId);
        if (!dialog.showModal) {
          dialogPolyfill.registerDialog(dialog);
        }
        dialog.showModal();
        if(!dialog.listened){
          dialog.querySelector('.close').addEventListener('click', function() {
            dialog.close();
          });
        }
        dialog.listened = true;
    },
    publishAdventure(){
      //there's a "weakness" here, 
      //someone could connect their published adv to a different (published) adventure
      //kinda like a link, wouldn't make a lot of sense, but well, can happen
      var publishedAdv = Object.assign({}, this.items[this.selectedId]);
      publishedAdv.owner = {
        'uid' : this.user.uid,
        'name' : this.user.displayName
      };
      publishedAdv.datePublished = Date.now()-1000; //1 seg of treshold 
      console.log(publishedAdv.datePublished);
      this.advPubRef.child(this.selectedId).set(publishedAdv);
      this.advDetailsRef.child(this.selectedId).child('published').set(true);
      this.advRef.child(this.selectedId).child('published').set(true);
      document.querySelector('dialog.publishAdventure').close();
      var data = {message: 'Your adventure "' + publishedAdv.name + '" was published!' };
      document.querySelector('#snackbar').MaterialSnackbar.showSnackbar(data);
    }
  }
}

</script>
<style>
  .mdl-dialog{
     text-align: left;
     width: 50%;
     min-width: 280px;
  }
  .mdl-dialog__title{
    font-size: 1.5em;
  }
</style>



// WEBPACK FOOTER //
// SectionMyAdventures.vue?0e690db7